import { FC, ReactNode } from 'react'
import JoinButton from 'components/features/pfm/JoinButton/JoinButton'
import Button from 'components/features/pfm/Button/Button'
import HowitworksVideo from 'components/features/pfm/HomePage/HowitworksVideo'
import * as styles from 'components/features/pfm/HomePage/HowitworksSection.styl'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { FEED_POSTS_PAGE } from 'constants/pages'


const COPIES = [
  [
    `Want to get married, have kids, or buy a new home? Create a plan and make your dreams come true.`,
    `When you need advice, anonymously chat with people like you and get answers from the community.`,
    `Unlock badges by helping others and earning Likes on your posts and comments.`,
  ],
  [
    `Track and manage your entire financial life using your peers as a benchmark.`,
    `Find out if you're overspending in certain categories, paying high interest rates, or not saving enough.`,
    `Comparisons are anonymous and based on a panel created in partnership with financial institutions.`,
  ],
  [
    `Our algorithms analyze your balances, transactions, and interest rates to find ways for you to improve.`,
    `Act on our recommendations to earn cash rewards which can be invested in Bitcoin.`,
    `There's no limit to how much you can earn, and your rewards never expire.`,
  ],
  [
    `Go Premium to video chat with a financial advisor every month.`,
    `Track your finances with beautiful charts, category drilldowns, and instant alerts.`,
    `Unlock coaching, advanced tracking, and more for just $20 per month.`,
  ],
]

function generateItemBullets (copies: string[]): ReactNode {
  const copiesChildren = copies.map((copy, idx) => (
    <li key={ idx }>
      <span className={ styles.bulletText }>{ copy }</span>
    </li>
  ))

  return (
    <ul className={ styles.itemBullets }>
      { copiesChildren }
    </ul>
  )
}

const HowitworksSection: FC = () => {

  const joinButtonChild = (
    <AnalyticsClick
      className={ styles.joinButtonWrapper }
      category='page_controls-homepage'
      action='click-join_cta'
      label='how_it_works'
    >
      <JoinButton
        theme='white'
        shadow='heavy'
        fullHeight
        fullWidth
      >
        Earn $5 Now
      </JoinButton>
    </AnalyticsClick>
  )

  const videoButtonChild = (
    <HowitworksVideo>
      <div className={ styles.videoButtonWrapper }>
        <Button
          theme='white'
          shadow='heavy'
          fullHeight
          fullWidth
        >
          <div className={ styles.videoButtonInnerWrapper }>
            <span>Play Video</span>
            <div className={ styles.playButtonWrapper } />
          </div>
        </Button>
      </div>
    </HowitworksVideo>
  )

  return (
    <section className={ styles.howitworksSection }>
      <h2 className={ styles.mainHeadline }>How It Works</h2>
      <div className={ styles.highlightItems }>

        <div className={ styles.highlightItem }>
          <div className={ styles.textWrapper }>
            <div className={ styles.title }>
              <div className={ styles.ordinal } />
              <div className={ styles.itemHeadline }>
                See how you compare <br className={ styles.visible375 } />with peers
              </div>
            </div>
            { generateItemBullets(COPIES[1]) }
            { videoButtonChild }
          </div>
          <img
            className={ styles.image }
            src='/images/homepage/ipad.png'
            alt='Link your accounts and see how you compare'
          />
          <div className={ styles.separator } />
        </div>

        <div className={ styles.highlightItem }>
          <div className={ styles.textWrapper }>
            <div className={ styles.title }>
              <div className={ styles.ordinal } />
              <div className={ styles.itemHeadline }>
                Set your goals and get advice from peers
              </div>
            </div>
            { generateItemBullets(COPIES[0]) }
            <AnalyticsClick
              className={ styles.joinButtonWrapper }
              category='page_controls-homepage'
              action='click-explore_advice'
            >
              <NavigationLink to={ FEED_POSTS_PAGE }>
                <Button
                  theme='white'
                  shadow='heavy'
                  fullHeight
                  fullWidth
                >
                  explore advice
                </Button>
              </NavigationLink>
            </AnalyticsClick>
          </div>
          <img
            className={ styles.image }
            src='/images/homepage/mac.png'
            alt='Set your goals and get advice from peers'
          />
          <div className={ styles.separator } />
        </div>

        <div className={ styles.highlightItem }>
          <div className={ styles.textWrapper }>
            <div className={ styles.title }>
              <div className={ styles.ordinal } />
              <div className={ styles.itemHeadline }>
                Get recommendations and<br className={ styles.earnBreak } /> earn cash or Bitcoin rewards
              </div>
            </div>
            { generateItemBullets(COPIES[2]) }
            { joinButtonChild }
          </div>
          <img
            className={ styles.image }
            src='/images/homepage/iphone.png'
            alt='Get recommendations and earn cash or Bitcoin rewards'
          />
          <div className={ styles.separator } />
        </div>

        <div className={ styles.highlightItem }>
          <div className={ styles.textWrapper }>
            <div className={ styles.title }>
              <div className={ styles.ordinal } />
              <div className={ styles.itemHeadline }>
                Unlock professional coaching &amp; more!
              </div>
            </div>
            { generateItemBullets(COPIES[3]) }
            <AnalyticsClick
              className={ styles.joinButtonWrapper }
              category='page_controls-homepage'
              action='click-try_premium'
            >
              <JoinButton
                theme='golden'
                shadow='heavy'
                fullHeight
                fullWidth
              >
                Join For Free
              </JoinButton>
            </AnalyticsClick>
          </div>
          <img
            className={ styles.image }
            src='/images/homepage/coaching.jpg'
            alt='Unlock professional coaching & more'
          />
          <AnalyticsClick
            className={ styles.joinButtonWrapper }
            category='page_controls-homepage'
            action='click-try_premium'
          >
            <JoinButton
              theme='golden'
              shadow='heavy'
              fullHeight
              fullWidth
            >
              Join For Free
            </JoinButton>
          </AnalyticsClick>
        </div>
      </div>
    </section>
  )
}

export default HowitworksSection
